import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../../shared/translation/translation.service';
import { IObject } from '../../../../type_definitions/datatypes';

@Component({
  selector: 'busy-button-demo',
  template: `
    <h3>BusyButton Demo</h3>

    Busy button without translation:<br />
    <button class="btn btn-success" (click)="buttonClicked()" [busyButton]="busy">Button</button> {{busy ? 'should show a spinner and disable' : ''}}

    <br /><br />

    <button class="btn btn-success" (click)="buttonClicked()" [busyButton]="busy" bb-prevent-disable="true">Button</button> {{busy ? 'should only show a spinner' : ''}}

    <br />

    <hr>
    <b>When using <i>[busyButton]</i> directive with <i>translate</i> you must wrap the translated value</b>

    <br /><br />

    Busy button with translation (<span style="color: red">NOT WORKING</span>):<br />
    <button class="btn btn-success" (click)="buttonClicked()" [busyButton]="busy" [translateParams]="imagesLabel" translate>GA.BUTTONS.ADD_LABEL</button> {{busy ? 'should show a spinner' : ''}}

    <br /><br />

    Busy button with translation (<span style="color: green">WORKING</span>):<br />
    <button class="btn btn-success" (click)="buttonClicked()" [busyButton]="busy">
      <span translate [translateParams]="imagesLabel">GA.BUTTONS.ADD_LABEL</span>
    </button> {{busy ? 'should show a spinner' : ''}}
  `
})
export class BusyButtonDemoComponent implements OnInit {
  public busy:boolean;
  public imagesLabel:IObject;

  constructor(
    private translationService:TranslationService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.imagesLabel = { label: this.translationService.instant('GA.GENERAL.IMAGES') };
  }

  public buttonClicked = ():void => {
    this.busy = true;
    setTimeout(() => {
      this.busy = false;
    }, 5000);
  };
}